import {
  METRIC_CATEGORY_LABELS,
  METRIC_CATEGORY_ORDER,
  MetricCategory,
} from '@chiroup/core/constants/metricCategories';
import {
  BookOpen,
  Building2,
  CalendarDays,
  ClipboardList,
  Database,
  DollarSign,
  UserCog,
  Users,
} from 'lucide-react';
import React from 'react';

type Props = {
  active: MetricCategory;
  onChange: (next: MetricCategory) => void;
  categoryTotals: Record<MetricCategory, number>;
};

const CATEGORY_ICONS: Record<MetricCategory, React.ElementType> = {
  schedule: CalendarDays,
  clinical: ClipboardList,
  billing: DollarSign,
  patients: Users,
  databases: Database,
  clinic_settings: Building2,
  user_settings: UserCog,
  resources: BookOpen,
};

const CATEGORY_COLORS: Record<MetricCategory, string> = {
  schedule: 'bg-green-500 hover:bg-green-600',
  clinical: 'bg-blue-500 hover:bg-blue-600',
  billing: 'bg-amber-500 hover:bg-amber-600',
  patients: 'bg-rose-500 hover:bg-rose-600',
  databases: 'bg-indigo-500 hover:bg-indigo-600',
  clinic_settings: 'bg-cyan-500 hover:bg-cyan-600',
  user_settings: 'bg-purple-500 hover:bg-purple-600',
  resources: 'bg-orange-500 hover:bg-orange-600',
};

const CategoryTabs: React.FC<Props> = ({ active, onChange, categoryTotals }) => {
  return (
    <div className="border-b border-gray-200/60 py-3 flex justify-center">
      <div className="bg-gradient-to-r from-white via-gray-50/50 to-white rounded-2xl px-3 py-2">
        <nav className="flex gap-1.5">
          {METRIC_CATEGORY_ORDER.map(cat => {
            const isActive = cat === active;
            const Icon = CATEGORY_ICONS[cat];
            const colorClass = CATEGORY_COLORS[cat];

            return (
              <button
                key={cat}
                type="button"
                onClick={() => onChange(cat)}
                className={`flex items-center gap-2 px-3.5 py-2 rounded-full font-medium transition-all duration-300 whitespace-nowrap flex-shrink-0 ${
                  isActive
                    ? `${colorClass} text-white shadow-md hover:shadow-lg`
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                <Icon
                  className={`h-4.5 w-4.5 flex-shrink-0 transition-colors duration-300 ${
                    isActive ? 'text-white' : 'text-gray-600'
                  }`}
                />
                <span className="text-sm">{METRIC_CATEGORY_LABELS[cat]}</span>
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default CategoryTabs;
